import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import React, { PropsWithChildren, useState } from "react"
import { useTranslation } from "react-i18next"
export interface ButtonConfirmProps {
    title?: string | React.ReactNode
    content?: string | React.ReactNode
    confirmText?: string | React.ReactNode
    cancelText?: string | React.ReactNode
    onConfirm?: () => void
    onCancel?: () => void
    onClose?: (confirmed:boolean) => void
    cancelId?: string
    confirmId?: string
}

export function ButtonConfirm({ title, content, confirmText, cancelText, onConfirm, onCancel, onClose , cancelId, confirmId, children }: ButtonConfirmProps & PropsWithChildren) {
    const [isOpen, setIsOpen] = useState(false)
    const {t} = useTranslation('fanfanlo/mui/dialog/content')
    return (
        <>
            <span onClick={() => setIsOpen(true)}>
                {children}  
            </span>
            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <DialogTitle>{title || t('ButtonConfirm.title')}</DialogTitle>
                <DialogContent>{content || t('ButtonConfirm.content')}</DialogContent>
                <DialogActions>
                    <Button id={cancelId || 'btn-dialog-button-confirm-cancel'}
                    data-id={cancelId || 'btn-dialog-button-confirm-cancel'}
                    onClick={()=>{setIsOpen(false); onCancel?.();onClose?.(false)}}>{cancelText || t('ButtonConfirm.cancel')}</Button>
                    <Button id={confirmId || 'btn-dialog-button-confirm-confirm'}
                    data-id={confirmId || 'btn-dialog-button-confirm-confirm'}
                    onClick={()=>{setIsOpen(false); onConfirm?.();onClose?.(true)}}>{confirmText || t('ButtonConfirm.confirm')}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
